import { Divider, Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { FixedSizeList } from 'react-window';
import { makeStyles } from 'tss-react/mui';
import { useSegments } from '../../../../sic-lib/api/hooks/useSegments';
import SegmentsItem from './SegmentsItem/SegmentsItem';

interface Props {
    windowHeight: number;
}

export default function Segments({ windowHeight }: Props) {
    const { classes } = useStyles();
    const { data, isSuccess, isFetching, isLoading, isError } = useSegments();

    if (!data) {
        return <></>;
    }

    return (
        <Grid item xs={true} marginTop={theme => theme.spacing(1)}>
            <Grid container justifyContent="center">
                <Typography variant="subtitle1" className={classes.title} gutterBottom>
                    Segments:
                </Typography>
            </Grid>
            <Divider />
            <FixedSizeList
                height={windowHeight - 30}
                itemCount={data ? data.length : 0}
                itemData={data || []}
                itemSize={57}
                width="100%"
            >
                {({ data, index, style }) => (
                    <div style={style}>
                        <SegmentsItem
                            key={data[index].segmentId}
                            segmentId={data[index].segmentId}
                            name={data[index].segmentName}
                        />
                    </div>
                )}
            </FixedSizeList>
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    title: {
        fontWeight: 'bold',
    },
}));
